import React from 'react';
import CancelSubscription from '../../components/CancelSubscription';

type CancelSubscriptionPageProps = {
  isWebview?: boolean;
};

export default function CancelSubscriptionPage({ isWebview = false }: Readonly<CancelSubscriptionPageProps>) {
  return <CancelSubscription isWebview={isWebview} />;
}
